import {defaultState} from "./state"

export default {
	getLotesSelecionadosByCreche: (state) => (cdCrecheSemLote, cdLoteProducaoCreche) => {
  	if (state.listaLotesAlocados.length === 0) return []

		return state.listaLotesAlocados.filter(lote => {
			return lote.cdCrecheSemLote === cdCrecheSemLote &&
					lote.cdLoteProducaoCreche === cdLoteProducaoCreche
		})

  },

  listaLotesAlocadosByLoteDestino: (state) => (idPlanejamentoAlojamentoLoteDestino, cdCrecheSemLote, cdLoteProducaoCreche) => {
  	if (state.listaLotesAlocados.length === 0) return []

		return state.listaLotesAlocados.filter(lote => {
			return lote.cdPlanejamentoAlojamentoLoteDestino === idPlanejamentoAlojamentoLoteDestino &&
					lote.cdCrecheSemLote === cdCrecheSemLote &&
					lote.cdLoteProducaoCreche === cdLoteProducaoCreche
		})

  },
	listaLotesAlocadosForaCrechario: (state) => (cdCrecheSemLote, cdLoteProducaoCreche) => {
  	if (state.listaLotesAlocados.length === 0) return []

		return state.listaLotesAlocados.filter(lote => {
			return !(lote.cdCrecheSemLote === cdCrecheSemLote &&
					lote.cdLoteProducaoCreche === cdLoteProducaoCreche)
		})
  },
	somaQtTotalAlocados: (state) => (idPlanejamentoAlojamentoLoteDestino) => {
  	if (state.listaLotesAlocados.length === 0) return 0

		const lotesAlocadosMesmoLoteDestino = state.listaLotesAlocados.filter(lote => lote.cdPlanejamentoAlojamentoLoteDestino === idPlanejamentoAlojamentoLoteDestino)

		return lotesAlocadosMesmoLoteDestino.length > 0 ?
				lotesAlocadosMesmoLoteDestino.reduce((acc, lote) => acc + parseInt(lote.qtMachosAlocados) + parseInt(lote.qtFemeasAlocados), 0) :
				0
  },
}